///<reference path="../../common/decorators.ts"/>
namespace TotalCore.Dashboard.Components {
    import Component = TotalCore.Common.Component;

    @Component('components.dashboard', {
        templateUrl: 'dashboard-credits-component-template',
        bindings: {}
    })
    class DashboardCreditsComponent {

    }
}